// extracted by mini-css-extract-plugin
export default {"container":"BetMaker_container__YVDTy"};